<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        起名废系列之“朱”姓拯救指南
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年2月26日</Col>
      </Row>
      <p></p>
      <p>和其他姓氏相比，“朱”姓重要特点总结如下，在起名时需要特别注意。</p>
      <div class="contentImg">
        <img src="@/assets/nameatl2.jpg" />
      </div>
      <p></p>
      <h3 >音韵</h3>
      <p></p>
      <p>和“朱”同音的字：猪、侏、诛、珠、蛛</p>
      <p>要特别注意“猪”这个高频字造成的谐音。</p>
      <p>朱欢（猪獾）: 全国3703人</p>
      <p>朱沙（诛杀 朱砂）：全国有755人</p>
      <p></p>
      <h3>人口，姓氏排名</h3>
      <p>2019年度的人口排名第14，有1800多万人。要起一个好一点的名字也是有难度的。坚决避免两个字的名字。</p>
      <p>朱英：全国有 11362 人</p>
      <h3>姓氏含义</h3>
      <p></p>
      <p>色彩系姓氏之一（朱 赤 橙 黄 绿 青 蓝 紫 黑 白 灰 褐 乌 红 粉）：</p>
      <p>（1）红色：～红。～批。～笔。～文（印章上的阳文）。～门（红漆大门，旧时指豪富人家）。  朱云飞</p>
      <p>（2）矿物名：～砂（无机化合物，中医用于镇静剂。亦称“辰砂”、“丹砂”）。～墨</p>
      <p>（3）姓。</p>
      <h3 >姓氏名人起名案例分析</h3>
      <p></p>
      <h4>1、皇家姓氏之一</h4>
      <div class="contentImg">
        <img src="@/assets/nameatl22.jpg" />
      </div>
      <p>【明太祖朱元璋】（1328年10月21日－1398年6月24日），或称洪武帝，明朝开国皇帝，原名朱重八，曾改名朱兴宗，投军被郭子兴取名元璋，字国瑞，生于濠州钟离县。庙号“太祖”，谥号“开天行道肇纪立极大圣至神仁文义武俊德成功高皇帝”，统称“太祖高皇帝”。在位三十一年，因年号洪武也俗称洪武帝。</p>
      <p>明朝各个皇帝的名号还是避一避吧，可以查我们数据库仔细看看。</p>
      <p>【朱自清】（1898年11月22日－1948年8月12日），原名自华，字佩弦，号秋实，原籍浙江绍兴，生于江苏东海，长大于江苏扬州，故称“我是扬州人”。他毕业于国立北京大学(现北京大学)，曾任国立清华大学(现清华大学)中国文学系教授、系主任。朱自清是近代中国著名诗人、散文家、学者，其著作合编为《朱自清全集》。“自清”出自《楚辞·卜居》：”意思为廉洁正直使自己保持清白。字佩弦，因朱自清自感性情迟缓，感于《韩非子》中“董安于之性缓，故佩弦以自急”之语，乃字“佩弦”以自警策。</p>
      <p>战国·韩·韩非子：“西门豹之性急，故佩韦以自缓；董安于之性缓，故佩弦以自急。”【释义】：弦，弓弦。韦，皮带。西门豹性子急，常身佩熟牛皮以此来提醒自己要像熟牛皮那样软韧，诸事不可急躁；董安于性情迟缓，常佩绷紧的弦在身上，用以自戒。</p>
      <p>【朱与言】（？－1455年），字一鹗，江西万安人，明朝政治人物，进士出身。永乐九年（1411年）辛卯科二甲第二十四名进士。宣德年间，历任四川副使。以平定合州盗患立功，升任合州同知。正统初年，召为南京右副都御史。以年老致仕去世。宣德年间，朱与言任四川按察副使期间，以捕盗至郫县，怒知县孙祥不缉捕不力，杖二十。五天后孙祥伤重去世。英宗登极，巡按御史上奏此事，申请追究朱与言之罪，但被英宗赦免。</p>
      <p>【朱日辉】 明代医学家。著有《医学元要》、《加减十三方》、《试验奇方》等书，未见行世。</p>
      <p>【朱百度】 江苏宝应人,字午桥。有〈汉碑征经〉。(〈清朝续文献通 考〉卷二五九)</p>
      <p>【朱君绪】 (?--720)中唐人。字法满，玉清观道士，三洞法师。</p>
      <p>【朱俊格】[明]代简王裔孙。嗜学善属文，聚书数万卷，尤好古篆籀墨迹，手模六十余卷勒石，名崇理帖。</p>
      <p>【朱晞颜】(1132年～1200年)，字子渊、子囝，休宁（今安徽休宁)人，宋孝宗隆兴元年(1163年）进士，曾知靖州永平县，政绩颇好，当地为他立了生祠。隆兴元年调当阳尉。历知永平、广济县，通判阆州，知兴国军、吉州，广南西路、京西路转运判官。光宗绍熙四年，除知静江府。宁宗庆元二年除太府少卿，总领淮东军马钱粮。四年，迁权工部侍郎，俄兼实录院同修撰。五年，兼知临安府。六年卒，年六十六。著作已佚，仅《两宋名贤小集》卷二一七存《桂巖吟藁》一卷。事见《新安文献志》卷八二宋谈钥《朱公行状》。</p>
      <div class="contentImg">
        <img src="@/assets/nameatl21.jpg" />
      </div>
    </div>
  </div>

  
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .contentImg {
    text-align: center;
    img {
      width: 600px;
    }
    @media screen and(max-width:1200px) {
      img {
        width: 400px;
      }
    }
  }
  .listai {
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
      text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
